import { render, staticRenderFns } from "./IASuite.vue?vue&type=template&id=2889458f&scoped=true&"
import script from "./IASuite.vue?vue&type=script&lang=ts&"
export * from "./IASuite.vue?vue&type=script&lang=ts&"
import style0 from "./IASuite.vue?vue&type=style&index=0&id=2889458f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2889458f",
  null
  
)

export default component.exports